// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ll-0";